import { render } from "./ProductSection.vue?vue&type=template&id=3f504780&scoped=true&bindings={}"
import script from "./ProductSection.vue?vue&type=script&lang=ts"
export * from "./ProductSection.vue?vue&type=script&lang=ts"

import "./ProductSection.vue?vue&type=style&index=0&id=3f504780&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f504780"

export default script